import React, { useMemo } from 'react';
import { Spinner } from 'reactstrap';
import EChartsDoughnutChart from '../../../../Components/Common/Charts/ECharts/EChartsDoughnutChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const BreachByActivityStatusChart = ({ data, isLoading }) => {
	const chartData = Array.isArray(data) ? data : [];

	const options = useMemo(
		() => ({
			tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
			legend: { top: '5%', left: 'center' },
			color: generateColorGradient(chartData.length || 1),
			series: [
				{
					name: 'Estado de Actividad',
					type: 'pie',
					radius: ['40%', '70%'],
					avoidLabelOverlap: false,
					itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
					label: { show: false, position: 'center' },
					labelLine: { show: false },
					data: chartData.map(d => ({ value: d.count, name: d.name || 'Sin datos' })),
				},
			],
		}),
		[chartData]
	);

	if (isLoading) {
		return (
			<div className='d-flex justify-content-center align-items-center py-4'>
				<Spinner size='sm' />
			</div>
		);
	}

	if (!chartData.length) {
		return (
			<div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'>
				<i className='ri-pie-chart-line fs-1 mb-2'></i>
				<p className='mb-0'>Sin datos disponibles</p>
			</div>
		);
	}

	return <EChartsDoughnutChart options={options} />;
};

export default React.memo(BreachByActivityStatusChart);
